import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const editarMotivoCancelacion = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.MOTIVO_REASIGNACION.UPDATE}${params.id}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default editarMotivoCancelacion;